import { Alert, AlertIcon, Text } from '@chakra-ui/react';

import { useCurrentDraft } from '../../hooks/useCurrentDraft';

/** Notice for routes with no automated apply path (e.g. historical UpdateRequest drafts). */
export const UnsupportedRouteNotice = () => {
  const { draft } = useCurrentDraft();

  return (
    <Alert status="info" borderRadius="md">
      <AlertIcon />
      <Text>
        This draft was recorded for visibility only — the <b>{draft?.route}</b> route has no automated apply path.
        Handle it by hand on the request, then discard this draft.
      </Text>
    </Alert>
  );
};
